import { useQuery } from '@tanstack/react-query';
import { IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ISupportThread } from '../../models/Support/ISupportThread';
import {
	SUPPORT_PATHS,
	SUPPORT_POLL_INTERVAL_MS,
	SUPPORT_QUERY_KEYS,
	supportPollingOptions,
} from './supportQueryHelpers';

interface SupportThreadsQueryOptions {
	/** Override the default polling interval (in ms). Pass `false` to disable polling. */
	refetchInterval?: number | false;
}

export function useSupportThreadsQuery(ticketId: string, options: SupportThreadsQueryOptions = {}) {
	const { refetchInterval = SUPPORT_POLL_INTERVAL_MS } = options;
	const userSession = useUserSession();

	return useQuery({
		queryKey: SUPPORT_QUERY_KEYS.tickets.threads(ticketId),
		...supportPollingOptions(refetchInterval),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IPagedCollection<ISupportThread>>(
				SUPPORT_PATHS.threads.list(ticketId),
				'GET'
			),
		enabled: !!ticketId,
		meta: { toastErrorMessage: 'Failed to load conversation' },
	});
}
